import { VerificationSettings } from "types/landlord/reports";
import { IncomeType } from "shared/types";
import { DocType } from "./types";

// Offer exactly the document types the verification template enables for this income type — the
// same source of truth AX uses — so a government-benefits income can be re-verified with a benefit
// letter instead of being forced into a paystub or W2 (BSCPF-6301).
export const getAllowedDocTypes = (
  settings?: VerificationSettings,
  incomeType?: IncomeType
): DocType[] => {
  const config = incomeType ? settings?.[incomeType] : undefined;
  const allowed = [
    DocType.Paystub,
    DocType.W2,
    DocType.Form1099,
    DocType.BenefitsStatement
  ].filter((docType) =>
    // The template enables 1099s per form kind; the API takes both as one type.
    docType === DocType.Form1099
      ? config?.form_1099_nec?.allowed || config?.form_1099_misc?.allowed
      : config?.[docType]?.allowed
  );

  // Without settings we cannot tell what is enabled; keep the historic pay stub / W2 pair.
  return allowed.length ? allowed : [DocType.Paystub, DocType.W2];
};
